import type { TProjectSettingsTag } from '@cascade/api-client/project-settings';
import { areRecordsEqual, isKeyOf } from '@cascade/core/utils';
import type { TTagGroup } from '#providers/projects/Projects.types.ts';

const isSameTagValue = (left = '', right = ''): boolean => left === right;

const getTagValueLabels = (
  tags: TProjectSettingsTag[],
  key: string,
): TProjectSettingsTag['values'] =>
  tags.find((tag) => tag.key === key)?.values ?? {};

export const getTagValues = (tags: TProjectSettingsTag[]): TTagGroup =>
  Object.fromEntries(tags.map((tag) => [tag.key, tag.value ?? '']));

export const hasRequiredTagValues = (
  tags: TProjectSettingsTag[],
  values: TTagGroup,
): boolean => tags.every((tag) => !tag.required || Boolean(values[tag.key]));

export const areTagGroupsEqual = (left: TTagGroup, right: TTagGroup): boolean =>
  areRecordsEqual(left, right, isSameTagValue);

export const isTagValueRegistered = (
  tags: TProjectSettingsTag[],
  key: string,
  value: string,
): boolean => {
  const labels = getTagValueLabels(tags, key);

  return isKeyOf(labels, value);
};

export const getTagValueLabel = (
  tags: TProjectSettingsTag[],
  key: string,
  value: string,
): string => {
  const labels = getTagValueLabels(tags, key);

  return isKeyOf(labels, value) ? labels[value] || value : value;
};
